import type { AppDependencies } from './defaultDependencies';
import type { PropsWithChildren } from 'react';
import { DependenciesContext } from './DependenciesContext';
import { useDependencies } from './useDependencies';
/**
 * @deprecated This file is deprecated and will be removed in the future.
 * Use specific page dependency context or common dependencies from `common.ts`.
 */
export function DependenciesProvider({
  children,
  dependencies,
}: PropsWithChildren<{ dependencies: Partial<AppDependencies> }>) {
  const currentDependencies = useDependencies();

  return (
    <DependenciesContext.Consumer>
      {(currentValue) => (
        <DependenciesContext.Provider
          value={{
            ...currentDependencies,
            ...currentValue,
            ...dependencies,
          }}
        >
          {children}
        </DependenciesContext.Provider>
      )}
    </DependenciesContext.Consumer>
  );
}
